<template>
  <v-menu close-on-click close-on-content-click offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" class="hidden-sm-and-down font-weight-bold pl-0">
        <v-avatar size="36" class="mx-1">
          <img v-if="user.avatar" alt="Avatar" v-bind:src="user.avatar" />
          <v-icon v-else>fas fa-user</v-icon>
        </v-avatar>
        <div v-if="user.name">{{ user.name }}</div>
        <div v-else>Profile</div>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, index) in menuItems" :key="index" link v-bind:to="{ name: item.url }" dense>
        <v-list-item-icon class="mr-0">
          <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: "SettingsMenu",
    data() {
      return {
        menuItems: [
          {
            title: "Settings",
            icon: "fa-cog",
            url: "AccountSettings",
          },
          {
            title: "Logout",
            icon: "fa-sign-out-alt",
            url: "Logout",
          },
        ],
      };
    },
    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/SettingsMenu.vue